import React, { useState } from 'react'
import { Card, Col, Flex, Form, Row } from 'antd'
import { ModuleTopHeading, PaymentTable, SearchInput } from '../../components';

const PaymentPage = () => {

    const [form] = Form.useForm();
    const [ visible, setVisible ] = useState(false)

    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Payment' onClick={()=> setVisible(true)}/>
                            <Form
                                form={form}
                                layout="vertical"
                            >
                                <Row gutter={[16,16]} align={'middle'}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <SearchInput 
                                            name='name'
                                            placeholder='Search'
                                            value={form.getFieldValue('name') || ''}
                                            prefix={<img src='/assets/icons/search.png' width={20} />}
                                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <PaymentTable
                            visible={visible}
                            setVisible={setVisible}
                        />
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { PaymentPage }
